import React, { useState, useEffect, useRef } from 'react';
import 'NOTICEBOARD/Components/Reports/DeprtmentNoticeCount/departmentnoticecount.css';
import NoticeboardAPICall from 'NoticeboardAPICall';
import config from 'config';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Spinner from 'NOTICEBOARD/CommonResources/SpinnerLoader/Spinner';
import { useReactToPrint } from 'react-to-print';
import ReactHtmlParser from 'react-html-parser';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';

function DepartmentNoticeCount() {

    const [academicYearList, setAcademicYearList] = useState({});
    const [academicYearSortedArr, setAcademicYearSortedArr] = useState([]);
    const [filterAcademicYear, setFilterAcademicYear] = useState( [config?.instructorInfo?.AcaYearId] );
    const [selectedAcademicYear, setSelectedAcademicYear] = useState([config?.instructorInfo?.AcaYear]);
    const [fetchingCountReport, setFetchingCountReport] = useState(false);
    const [countReportDetails, setCountReportDetails] = useState({});
    const [filterApplied, setFilterApplied] = useState(false);
    const [filterDisplay, setFilterDisplay] = useState(true);
    const [visibility, setVisibility] = useState([
        { name: 'Department', visibility: true }
    ]);

    const componentRef = useRef();

    useEffect(() => {
        apiCallToGetAcademicYearList();
        apiCallToGetNoticeCount();
    }, []);

    // API CALL METHOD TO GET ACADEMIC YEAR LIST
    const apiCallToGetAcademicYearList = async () => {
        let formData = {
            iid: config.institute_id,
        };

        let jsonResponse = await NoticeboardAPICall.makeApiCall(
            "GetAcademicYearListObject",
            formData,
            '/api/admission/streamManagement.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                apiCallToGetAcademicYearList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                setAcademicYearSortedArr(jsonResponse.APIResult.sortedIdArray);

                if(Object.keys(apiResult).length > 0) {
                    Object.keys(apiResult).map(yearId => {
                        apiResult[yearId]['yearId'] = yearId;
                    });
                }
                setAcademicYearList(apiResult);
            }
        }
    }

    // METHOD TO SELECT ACADEMIC YEAR
    const selectFilterYear = (year) => {
        let filterYear = filterAcademicYear;
        let selectedYear = selectedAcademicYear;

        if(filterYear.includes(year.yearId)) {
            filterYear = filterYear.filter(id => id != year.yearId);
            selectedYear = selectedYear.filter(text => text != year.year_text);
        }else {
            filterYear.push(year.yearId);
            selectedYear.push(year.year_text);
        }

        setFilterAcademicYear([ ...filterYear ]);
        setSelectedAcademicYear([ ...selectedYear ]);
    }

    // METHOD TO APPLY FILTER
    const applyFilter = () => {
        setFilterApplied(true);
        setFilterDisplay(false);
        apiCallToGetNoticeCount();
    }

    // API CALL METHOD TO GET NOTICE COUNT DETAILS
    const apiCallToGetNoticeCount = async () => {
        setFetchingCountReport(true);

        let requestData = {
            "iid": config.institute_id,
            "academicYearArray": filterAcademicYear || [config?.instructorInfo?.AcaYearId]
        };

        let jsonResponse = await NoticeboardAPICall.makeApiCall(
            "departmentWiseNoticeCount",
            requestData,
            '/api/notice/notice.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                apiCallToGetNoticeCount();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                if(Object.keys(apiResult).length > 0) {
                    Object.values(apiResult).map((stream, streamIndex) => {
                        if(streamIndex == 0) {
                            let visibilityDetails = visibility;
                            visibilityDetails = [
                                { name: 'Department', visibility: true }
                            ];
                            if(Object.keys(stream.yearData).length > 0) {
                                Object.values(stream.yearData).map(year => {
                                    let visibilityObject = {};
                                    visibilityObject['name'] = year.yearText;
                                    visibilityObject['visibility'] = true;

                                    visibilityDetails.push(visibilityObject);
                                });
                            }
                            setVisibility([ ...visibilityDetails ]);
                        }
                    });
                }
                setCountReportDetails(apiResult);
                setFetchingCountReport(false);
            }
        }
    }

    // METHOD TO CLEAR FILTER
    const clearFilter = () => 
    {
        setFilterAcademicYear([]);
        setSelectedAcademicYear([]);
        setCountReportDetails({});
        setFilterDisplay(false);
        setVisibility([
            { name: 'Department', visibility: true }
        ]);
        setFilterApplied(false);
    }

    // METHOD TO UPDATE COLUMN DISPLAY
    const updateColumnDisplay = (index) => {
        let visibilityDetails = visibility;

        visibilityDetails[index].visibility = !visibilityDetails[index].visibility;

        setVisibility([ ...visibilityDetails ]);
    }

    // METHOD TO PRINT REPORT
    const printReport = useReactToPrint({
        content: () => componentRef.current,
    });

    // METHOD TO EXPORT REPORT
    const exportReport = () => {
        document.getElementById('exportReport').click();
    }

    // METHOD TO RETURN REPORT TABLE COMPONENT
    const ReportTable = React.forwardRef((props, ref) => {
        return(
            <div className="mainDataContainer">
                {
                    fetchingCountReport ?
                        <Spinner />
                        :
                        <>
                            {
                                Object.keys(countReportDetails).length > 0 ?
                                    <div className="report-container" ref={componentRef}>
                                        <div className="college-info">
                                            <img className="report-college-logo" alt="college-logo" src={config.instructorInfo.InstituteLogo} />
                                            <p className="report-college-name">{ReactHtmlParser(config.institute_full_name)}</p>
                                        </div>
                                        <div className="report-name-print col-md-12">
                                            Department wise Notice Count Report
                                        </div>
                                        <div className="col-md-12 reportDetails-container" style={{ padding: 0 }}>
                                            <table className="table table-bordered table-responsive-sm" id="countTable" style={{ backgroundColor: '#FFF' }}>
                                                <thead>
                                                    <tr style={{ display: 'none' }}>
                                                        <th style={{ padding: 5 }} colSpan={visibility.length + 1}>
                                                            {ReactHtmlParser(config.institute_full_name)}
                                                        </th>
                                                    </tr>
                                                    <tr>
                                                        <th style={{ padding: 5 }}>Sr. No.</th>
                                                        {
                                                            visibility.map(header => {
                                                                if (header.visibility) {
                                                                    return (
                                                                        <th style={{ padding: 5 }}>{header.name}</th>
                                                                    );
                                                                }
                                                            })
                                                        }
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        Object.keys(countReportDetails).length > 0 ?
                                                            Object.values(countReportDetails).map((stream, streamIndex) => {
                                                                return (
                                                                    <tr key={stream.stream_name}>
                                                                        <td style={{ padding: 5 }}>{streamIndex + 1}.</td>
                                                                        {
                                                                            visibility[0].visibility &&
                                                                            <td style={{ padding: 5 }}>{stream.stream_name}</td>
                                                                        }
                                                                        {
                                                                            Object.keys(stream.yearData).length > 0 &&
                                                                            Object.values(stream.yearData).map((year, yearIndex) => {
                                                                                return (
                                                                                    <>
                                                                                        {
                                                                                            visibility[yearIndex + 1].visibility &&
                                                                                            <td style={{ padding: 5 }}>{year.count}</td>
                                                                                        }
                                                                                    </>
                                                                                );
                                                                            })
                                                                        }
                                                                    </tr>
                                                                );
                                                            })
                                                            :
                                                            <tr>
                                                                <td style={{ padding: 5 }}>No notice count found for selected academic year(s).</td>
                                                            </tr>
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    :
                                    <p style={{ marginTop: 10, fontSize: 14 }}>Please select academic year from filter to get details.</p>
                            }
                        </>
                }
            </div>
        );
    });

    return (
        <>
            <div className="col-md-12">
                <div className="filter-options">
                    <div className="filter-values col-md-6" style={{ paddingLeft: 0 }}>
                        <button className="btn outline-button" onClick={() => setFilterDisplay(!filterDisplay)}>
                            <FontAwesomeIcon icon={['fas', 'filter']} style={{ marginRight: 5 }} />
                            Filter
                        </button>
                    </div>
                    {
                        (Object.keys(countReportDetails).length > 0 && !fetchingCountReport) &&
                            <div className="export-values col-md-6" style={{ paddingRight: 0 }}>
                                <div style={{ display: 'none' }}>
                                    <ReactHTMLTableToExcel
                                        id="exportReport"
                                        className="download-table-xls-button btn btn-success mb-3"
                                        table="countTable"
                                        filename="Department wise Notice Count Report"
                                        sheet="tablexls"
                                        buttonText="Export"
                                    />
                                </div>
                                <button className="btn outline-button filter-button" onClick={() => exportReport()}>
                                    <FontAwesomeIcon icon={['fas', 'file-export']} style={{ marginRight: 5 }} />
                                    Export
                                </button>
                                <button className="btn outline-button filter-button" onClick={() => printReport()}>
                                    <FontAwesomeIcon icon={['fas', 'print']} style={{ marginRight: 5 }} />
                                    Print
                                </button>
                                <div className="setting-button">
                                    <div className="dropdown dropleft">
                                        <FontAwesomeIcon className="reportFilter-icon" title="Click to select required columns in the report" data-toggle="dropdown" icon={['fas', 'cog']} style={{ cursor: 'pointer' }} />
                                        <div id="settingDropdown" className="dropdown-menu filterDropdownMenu">
                                            {
                                                visibility.map((columnInfo, index) => {
                                                    return (
                                                        <p className="dropdown-item" style={{ display: 'flex', alignItems: 'center', padding: '5px 10px' }} key={columnInfo.name} onClick={() => updateColumnDisplay(index)}>
                                                            <input type="checkbox" style={{ marginRight: 5 }} checked={columnInfo.visibility} />
                                                            <span style={{ fontSize: 14  }}>{columnInfo.name}</span>
                                                        </p>
                                                    );
                                                })
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                    }
                </div>
                {
                    filterDisplay &&
                        <div style={{ marginTop: 10 }} className="filter-container">
                            <div className="filter-details">
                                <div className="academicYear" style={{ paddingLeft: 0 }}>
                                    <label style={{ marginBottom: 0, fontSize: 14, fontWeight: 'bold' }}>Academic Year <span style={{ color: 'red' }}>*</span></label>
                                    <div className="dropdown">
                                        <input
                                            type="text"
                                            className="form-control filterReportInput"
                                            placeholder='Click to select academic year'
                                            data-toggle="dropdown"
                                            readOnly
                                        />
                                        <div id="academicYearDropdown" className="dropdown-menu filterDropdownMenu" style={{ width: '100%' }}>
                                            {
                                                Object.keys(academicYearList).length > 0 ?
                                                academicYearSortedArr.map(yearId => {
                                                    let year  = academicYearList[yearId];
                                                        return (
                                                            <p className="dropdown-item" style={{ display: 'flex', alignItems: 'center', padding: '5px 10px' }} key={year.yearId} onClick={() => selectFilterYear(year)}>
                                                                <input
                                                                    type='checkbox'
                                                                    checked={filterAcademicYear.includes(year.yearId)}
                                                                    style={{ marginRight: 5 }}
                                                                />
                                                                <span style={{ fontSize: 14 }}>{year.year_text}</span>
                                                            </p>
                                                        );
                                                    })
                                                :
                                                    <p style={{ color: '#818181', fontSize: 12 }}>No academic year details found.</p>
                                            }
                                        </div>
                                        <p style={{ fontSize: 14 }}>{selectedAcademicYear.join(', ')}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="filter-buttons">
                                <button className="btn primary-button filter-button" onClick={() => applyFilter()} disabled={filterAcademicYear.length == 0}>Apply</button>
                                <button className="btn outline-button filter-button" onClick={() => clearFilter()}>Clear</button>
                            </div>
                        </div>
                }
                <ReportTable />
            </div>
        </>
    )
}

export default DepartmentNoticeCount;